import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { setFlashAlert } from '../../redux/features/ui/uiSlice'

// The route for a page that needs a signed-in user, when nobody is signed in:
// go to the sign in screen and say why. The flash is set and the navigation
// made in the same run, so the flash survives it (see router/flashClearing.js).
export default function SignInRequired() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    dispatch(setFlashAlert('You need to sign in or sign up before continuing.'))
    navigate('/app/sign_in', { replace: true })
  }, [])

  return null
}
